import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, MenuItem, ClickAwayListener }
 from '@mui/material';

// project import
import Avatar from '@/from-theme/components/@extended/Avatar';
import useAuth from '@/from-theme/hooks/useAuth';
import { useGetMenuMaster } from 'api/menu';

// assets
import { RightOutlined } from '@ant-design/icons';

// const avatarImage = require.context('assets/assets/images/users', true);

const ExpandMore = styled(IconButton, { shouldForwardProp: (prop) => prop !== 'theme' && 
prop !== 'expand' && prop !== 'drawerOpen' })(
  ({ theme, expand, drawerOpen }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(-90deg)',
    marginLeft: 'auto',
    color: theme.palette.secondary.dark,
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    ...(!drawerOpen && {
      opacity: 0,
      width: 50,
      height: 50
    })
  })
);

// ==============================|| DRAWER - USER ||============================== //

const NavUser = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const { logout, userData, deactivate } = useAuth();
  const user = userData?.data;
  
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeactivate = async () => {
    try {
      await deactivate();
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    const el = event.currentTarget;
    setAnchorEl(el);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ position: 'relative', p: 1.25, px: !drawerOpen ? 1.25 : 3, borderTop: `2px solid 
    ${theme.palette.divider}` }}>
      <List disablePadding>
        <ListItem
          disablePadding
          secondaryAction={
            <ExpandMore
              size="small"
              expand={open.toString()}
              drawerOpen={drawerOpen}
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              aria-label="show more"
            >
              <RightOutlined style={{ fontSize: '0.625rem' }} />
            </ExpandMore>
          }
          sx={{ '& .MuiListItemSecondaryAction-root': { right: !drawerOpen ? -20 : -16 } }}
        >
          <ListItemAvatar>
            <Avatar alt="Avatar" src={user?.image} sx={{ ...(drawerOpen &&
               { width: 46, height: 46 }) }} />
          </ListItemAvatar>
          <ListItemText primary={user?.employeeName} secondary={user?.designationName} />
        </ListItem>
      </List>
      {open && (
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            elevation={3}
            sx={(theme) => ({
              position: 'absolute',
              right: drawerOpen ? 24 : 16,
              bottom: 72,
              width: 160,
              zIndex: theme.zIndex.modal,
              p: 0,
              borderRadius: 1,
              bgcolor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              boxShadow: theme.customShadows?.z1 || theme.shadows[4],
              border: `1px solid ${theme.palette.divider}`
            })}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
            <MenuItem onClick={handleDeactivate}>Deactivate</MenuItem>
            {/* <MenuItem component={Link} to="#" onClick={handleClose}>
              Profile
            </MenuItem>
            <MenuItem component={Link} to="#" onClick={handleClose}>
              My account
            </MenuItem> */}
          </Paper>
        </ClickAwayListener>
      )}
    </Box>
  );
};

export default NavUser;
